module.exports = {
    "Empty": `Vide`
};


//# sourceMappingURL=fr-FR.main.js.map
